import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaCaretDown } from "react-icons/fa";
import { getProducts } from "../utils/productCache";
import EventsModal from "./EventsModal";

const Navbar = ({ onOpenContact }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isEventsOpen, setIsEventsOpen] = useState(false);

  // Asegúrate de poner aquí tu número real (solo números, sin el +)
  // Ejemplo para Colombia: 57 + número
  const WHATSAPP_NUMBER = "573015114267"; 

  const normalize = (text) =>
    text?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const products = await getProducts();
        const unique = [];
        const seen = new Set();
        products.forEach((p) => {
          const norm = normalize(p.category);
          if (p.category && !seen.has(norm)) {
            seen.add(norm);
            unique.push(p.category);
          }
        });
        setCategories(unique);
      } catch (error) {
        console.error("Error cargando categorías:", error);
      }
    };
    loadCategories();
  }, []);

  const handleWhatsAppRedirect = () => {
    setIsEventsOpen(false);
    const message = encodeURIComponent("Hola FIORI, me gustaría recibir más información y una cotización para un evento.");
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
    
    // Usamos window.location.href para que no lo bloquee el navegador como un popup
    window.location.href = whatsappUrl;
  };

  return (
    <>
      <nav className="navbar">
        <ul>
          <li onClick={() => navigate("/")}>Inicio</li>
          <li className="dropdown">
            <div onClick={() => setIsDropdownOpen(!isDropdownOpen)} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "5px" }}>
              Productos <FaCaretDown />
            </div>
            {isDropdownOpen && (
              <ul className="dropdown-menu">
                {categories.map((category, index) => (
                  <li key={index} onClick={() => { navigate(`/menu_prod/${category}`); setIsDropdownOpen(false); }}>
                    {category}
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li onClick={() => setIsEventsOpen(true)}>Eventos</li>
          <li onClick={onOpenContact}>Contacto</li>
        </ul>
      </nav>

      <EventsModal 
        isOpen={isEventsOpen} 
        onClose={() => setIsEventsOpen(false)} 
        onContactClick={handleWhatsAppRedirect} 
      />
    </>
  );
};

export default Navbar;